/** Write roles for stoffkartotek (API: chemical_inventory OR hse_ks_risk OR admin). */
export const CHEMICAL_INVENTORY_WRITE_ROLES = [
  "chemical_inventory",
  "hse_ks_risk",
  "admin",
];

export function normalizeChemicalInventorySettings(raw) {
  const data =
    raw?.data !== undefined && raw.data !== null && typeof raw.data === "object"
      ? raw.data
      : raw && typeof raw === "object"
        ? raw
        : {};

  const responsibleIds = Array.isArray(data.responsible_user_ids)
    ? data.responsible_user_ids
    : Array.isArray(data.responsible_users)
      ? data.responsible_users.map((u) => u?.id).filter(Boolean)
      : [];

  return {
    employee_visibility: data.employee_visibility || "",
    responsible_user_ids: responsibleIds,
    responsible_users: Array.isArray(data.responsible_users)
      ? data.responsible_users
      : [],
    default_review_interval_months:
      data.default_review_interval_months != null
        ? Number(data.default_review_interval_months)
        : 12,
    require_sds: Boolean(data.require_sds),
    auto_create_from_products: Boolean(data.auto_create_from_products),
    review_reminder_enabled:
      data.review_reminder_enabled == null
        ? true
        : Boolean(data.review_reminder_enabled),
    sds_stale_after_months:
      data.sds_stale_after_months != null
        ? Number(data.sds_stale_after_months)
        : 36,
  };
}

export function snapshotChemicalInventorySettings(settings) {
  return JSON.stringify({
    employee_visibility: settings.employee_visibility || "",
    responsible_user_ids: [...(settings.responsible_user_ids || [])]
      .map(String)
      .sort(),
    default_review_interval_months: Number(
      settings.default_review_interval_months || 0
    ),
    require_sds: Boolean(settings.require_sds),
    auto_create_from_products: Boolean(settings.auto_create_from_products),
    review_reminder_enabled: Boolean(settings.review_reminder_enabled),
    sds_stale_after_months: Number(settings.sds_stale_after_months || 0),
  });
}

export function chemicalInventoryDocumentUrl(doc) {
  if (!doc || typeof doc !== "object") return null;
  const nested = doc.document || {};
  const nestedFile = nested.file || {};
  const original = nestedFile.original || {};
  return (
    doc.file_url ||
    doc.url ||
    doc.download_url ||
    nested.file_url ||
    nested.url ||
    nested.download_url ||
    nested.attachment_url ||
    nestedFile.url ||
    original.url ||
    null
  );
}

export function isSdsDocument(doc) {
  if (!doc || typeof doc !== "object") return false;
  const type = String(
    doc.document_type || doc.kind || doc.type || ""
  ).toLowerCase();
  return (
    type.includes("safety_data") ||
    type.includes("sds") ||
    type.includes("sikkerhetsdata")
  );
}

export function formatReviewLine(chemical, t) {
  const version = chemical?.version ?? chemical?.revision_number ?? "—";
  const next = chemical?.next_review_date
    ? new Date(chemical.next_review_date).toLocaleDateString()
    : t("chemical.inventory.next_review_missing");
  return t("chemical.inventory.revision_line", { version, date: next });
}
